import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.videoUrl
    ? _c(
        VApp,
        {
          staticClass: "d-inline-flex",
          attrs: { "data-video-card": "", "data-qa-is-lpu": "" },
        },
        [
          _c(VSheet, { attrs: { color: "transparent" } }, [
            _c(
              "div",
              {
                staticClass: "video-card-icon",
                attrs: { "data-qa": "video_card_play_icon" },
                on: { click: _setup.handleOpenDialog },
              },
              [
                _c(VImg, {
                  directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                  attrs: {
                    alt: _vm.$t("Открыть видеовизитку", {
                      ns: _vm.$i18next.language,
                    }),
                    width: "28",
                    height: "28",
                    src: "/static/_v1/pd/icons/ui-kit/video-card-play.svg",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _setup.isMobile
            ? _c(
                VDialog,
                {
                  attrs: {
                    "data-qa": "video_card_dialog",
                    fullscreen: "",
                    divider: "",
                  },
                  model: {
                    value: _setup.isDialogVisible,
                    callback: function ($$v) {
                      _setup.isDialogVisible = $$v
                    },
                    expression: "isDialogVisible",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "video-card-wrapper text",
                      attrs: { "data-qa": "video_card_dialog" },
                    },
                    [
                      _c("div", {
                        staticClass:
                          "video-card-player-close ui-icon_reset bg-gray-0--text ui-icon-close-not-a-circle",
                        on: {
                          click: function ($event) {
                            _setup.isDialogVisible = false
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "video-card-switch-state",
                        on: { click: _setup.videoSwitchState },
                      }),
                      _vm._v(" "),
                      !_setup.isVideoPlaying
                        ? _c("div", { staticClass: "video-card-play" }, [
                            _c("div", {
                              staticClass:
                                "ui-icon_reset primary--text ui-icon-player-play",
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _setup.videoTimeTotal && _setup.videoTimeCurrent
                        ? _c("div", { staticClass: "video-card-time-cover" }, [
                            _c("div", { staticClass: "video-card-time" }, [
                              _c(
                                "div",
                                { staticClass: "text-body-1 bg-gray-0--text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.videoTimeCurrent) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-body-1 bg-gray-60--text px-1",
                                },
                                [_vm._v("/")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-body-1 bg-gray-60--text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_setup.videoTimeTotal) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("video", {
                        ref: "videoRef",
                        staticClass: "video-card-player",
                        attrs: {
                          "data-qa": "video_card_video",
                          playsinline: "",
                          src: _vm.videoUrl,
                        },
                        on: {
                          timeupdate: _setup.handleTimeupdate,
                          loadedmetadata: _setup.handleLoadedmetadata,
                          ended: _setup.handleEnded,
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _c(
                _setup.CoreDialog,
                {
                  attrs: {
                    "data-qa": "video_card_dialog",
                    size: "lg",
                    title: _vm.$t("Видеовизитка", {
                      ns: _vm.$i18next.language,
                    }),
                    divider: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "prependBtn",
                        fn: function ({ btnProps }) {
                          return [
                            _c(
                              VBtn,
                              _vm._b(
                                {
                                  on: {
                                    click: function ($event) {
                                      _setup.isDialogVisible = false
                                    },
                                  },
                                },
                                "v-btn",
                                btnProps,
                                false
                              ),
                              [
                                _c("span", {
                                  staticClass: "ui-icon-close-not-a-circle",
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1322088010
                  ),
                  model: {
                    value: _setup.isDialogVisible,
                    callback: function ($$v) {
                      _setup.isDialogVisible = $$v
                    },
                    expression: "isDialogVisible",
                  },
                },
                [
                  _vm._v(" "),
                  _c("video", {
                    ref: "videoRef",
                    staticClass: "video-card-player",
                    attrs: {
                      "data-qa": "video_card_video",
                      controls: "",
                      src: _vm.videoUrl,
                    },
                    on: { ended: _setup.handleEnded },
                  }),
                ]
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }